import React from 'react';
import Reveal from './Reveal';
import { Package, Truck, TrendingUp } from 'lucide-react';
import { modelSteps } from '../../mock/content';

const icons = [Package, Truck, TrendingUp];

/**
 * Visual horizontal pipeline of the 3 model steps with animated flow-line + arrows.
 * Stacks vertically on mobile.
 */
const ProcessPipeline = () => {
  return (
    <div className="mt-16">
      {/* Desktop: horizontal pipeline */}
      <div className="hidden md:block relative">
        {/* Dashed animated flow line behind cards */}
        <div className="absolute top-[46px] left-[8%] right-[8%] h-px">
          <div className="w-full h-px border-t-2 border-dashed border-brand-blue/30" />
          {/* moving dot */}
          <div className="absolute -top-[3px] left-0 h-2 w-2 rounded-full bg-brand-blue shadow-mk-blue flow-dot" />
        </div>

        <div className="relative grid grid-cols-3 gap-6">
          {modelSteps.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={s.step} delay={i * 160} className="relative">
                {/* Numbered circle on top of the line */}
                <div className="flex justify-center">
                  <div className="relative">
                    <div className="w-[92px] h-[92px] rounded-full bg-white shadow-mk-lg flex items-center justify-center border-4 border-brand-blue/15">
                      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-brand-blue to-brand-blue-light text-white flex items-center justify-center shadow-mk-blue">
                        <Icon size={26} strokeWidth={2.2} />
                      </div>
                    </div>
                    <span className="absolute -top-1 -right-1 h-8 min-w-[32px] px-2 rounded-full bg-brand-pink text-white text-[12px] font-black flex items-center justify-center shadow-[0_4px_10px_0_rgba(233,30,99,0.35)]">
                      {s.step}
                    </span>
                  </div>
                </div>
                {/* Card */}
                <div className="mt-8 bg-white rounded-2xl shadow-mk p-6 text-center hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300">
                  <h3 className="text-navy text-[20px] font-bold">{s.title}</h3>
                  <p className="mt-3 text-body-muted text-[14px] leading-[1.7]">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>

      {/* Mobile: vertical pipeline */}
      <div className="md:hidden relative pl-14">
        <div className="absolute left-[26px] top-6 bottom-6 w-px border-l-2 border-dashed border-brand-blue/30" />
        <div className="space-y-6">
          {modelSteps.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={s.step} delay={i * 160} className="relative">
                <div className="absolute -left-14 top-0">
                  <div className="w-[52px] h-[52px] rounded-full bg-white shadow-mk-lg flex items-center justify-center border-4 border-brand-blue/15">
                    <div className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-blue to-brand-blue-light text-white flex items-center justify-center shadow-mk-blue">
                      <Icon size={16} strokeWidth={2.4} />
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-2xl shadow-mk p-6">
                  <span className="text-brand-blue text-[11px] font-black tracking-[0.16em] uppercase">
                    Step {s.step}
                  </span>
                  <h3 className="mt-2 text-navy text-[19px] font-bold">{s.title}</h3>
                  <p className="mt-2 text-body-muted text-[14px] leading-[1.7]">{s.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProcessPipeline;
